import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const TikTokCallback = () => {
    const [status, setStatus] = useState('Processing TikTok login...');
    const navigate = useNavigate();

    const CLIENT_KEY = 'sbawuqmkdx3ntukp5c';
    const CLIENT_SECRET = 'lgrjotwnE0I8UGFjxLd4IueCkb2LFPM0';
    const REDIRECT_URI = 'https://misoulmate.com/tiktok/callback';

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');

        if (!code || state !== 'secure123') {
            setStatus('❌ Missing or invalid TikTok code/state.');
            return;
        }

        const fetchToken = async () => {
            try {
                const response = await axios.post(
                    'https://open-sandbox.tiktokapis.com/v2/oauth/token',
                    {
                        client_key: CLIENT_KEY,
                        client_secret: CLIENT_SECRET,
                        code,
                        grant_type: 'authorization_code',
                        redirect_uri: REDIRECT_URI
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('✅ Token Response:', response.data);

                const { access_token, open_id } = response.data.data;

                localStorage.setItem('tiktok_access_token', access_token);
                localStorage.setItem('tiktok_open_id', open_id);

                setStatus('✅ TikTok connected! Redirecting...');
                setTimeout(() => navigate('/upload-video'), 2000);
            } catch (error) {
                console.error('❌ Token exchange failed:', error?.response?.data || error.message);
                setStatus('❌ TikTok connection failed. See console for details.');
            }
        };

        fetchToken();
    }, [navigate]);

    return (
        <div style={{ padding: 20 }}>
            <h2>{status}</h2>
        </div>
    );
};

export default TikTokCallback;
